import React, { useState, useEffect } from 'react';
import { LinkOutlined } from '@ant-design/icons';
import { routeNames } from 'routes';
import { Link } from 'react-router-dom';
import {
  useGetAccountInfo,
  useGetPendingTransactions
} from '@multiversx/sdk-dapp/hooks';
import Dropdown from 'react-bootstrap/Dropdown';
import axios from 'axios';
import BigNumber from 'bignumber.js';
import { convertEsdtToWei } from '../../utils/convert';
import './index.scss';
import {
  EVLD_SALE_PRICE,
  GATEWAY,
  VESTING_CONTRACT_ADDRESS,
  WEGLD_ID
} from 'config';
import {
  ArgSerializer,
  BigUIntValue,
  BytesValue,
  TransactionPayload,
  TypedValue
} from '@multiversx/sdk-core/out';
import { sendTransactions } from '@multiversx/sdk-dapp/services';
import { refreshAccount } from '@multiversx/sdk-dapp/utils';
import { paymentTokens, wrapContracts } from 'utils/const';

const SwapComponent = (props: any) => {
  const { hasPendingTransactions } = useGetPendingTransactions();

  const lastPath = window.location.pathname;
  const referralId = lastPath.split('/')[2];
  // console.log('referralId: ', referralId);

  const [inputAmount, setInputAmount] = useState<number>(0);
  const [inputString, setInputString] = useState<string>('');
  const [outputAmount, setOutputAmount] = useState<number>(0);
  const [termsChecked, setTermsChecked] = useState(false);
  const [paymentTokenIndex, setPaymentTokenIndex] = useState(1);
  const [tokenDetails, setTokenDetails] = useState<any>();
  const [currentPaymentTokenPrice, setCurrentPaymentTokenPrice] = useState(0);
  const [vestingAmountPerOneToken, setVestingAmountPerOneToken] = useState(0);
  const {
    address,
    account: { balance },
    shard
  } = useGetAccountInfo();
  const isLoggedIn = Boolean(address);

  useEffect(() => {
    (async () => {
      const config = {
        params: {
          size: 1000
        }
      };
      const url = `${GATEWAY}/mex/tokens`;
      const response = await axios.get(url, config);
      if (response.data.length <= 0) return;
      const tokenDetails = response.data;
      setTokenDetails(tokenDetails);
      console.log('token deetails: ', tokenDetails);
    })();
  }, []);

  useEffect(() => {
    let paymentTokenSymbol = paymentTokens[paymentTokenIndex].symbol;
    if (paymentTokenSymbol == 'EGLD') paymentTokenSymbol = 'WEGLD';
    const currentPaymentTokenDetails = tokenDetails?.find(
      (item: any) => item.symbol == paymentTokenSymbol
    );
    if (currentPaymentTokenDetails) {
      setCurrentPaymentTokenPrice(currentPaymentTokenDetails.price);
      setVestingAmountPerOneToken(
        currentPaymentTokenDetails.price / EVLD_SALE_PRICE
      );
    } else {
      if (paymentTokenSymbol == 'USDC') {
        setCurrentPaymentTokenPrice(1);
        setVestingAmountPerOneToken(1 / EVLD_SALE_PRICE);
        return;
      }
      setCurrentPaymentTokenPrice(0);
      setVestingAmountPerOneToken(0);
    }
  }, [paymentTokenIndex, tokenDetails]);

  useEffect(() => {
    if (hasPendingTransactions) return;
    setInputAmount(0);
    setInputString('');
  }, [hasPendingTransactions]);

  const startVesting = async () => {
    if (
      inputAmount * currentPaymentTokenPrice < 10 ||
      inputAmount * currentPaymentTokenPrice > 20000
    ) {
      alert('Minimum amount value is 10$');
      return;
    }

    let wrapAddress = wrapContracts.Wrap0.address;

    if (shard === 1) {
      wrapAddress = wrapContracts.Wrap1.address;
    } else if (shard === 2) {
      wrapAddress = wrapContracts.Wrap2.address;
    }

    if (paymentTokenIndex == 0) {
      // egld
      const amount = new BigNumber(inputAmount).multipliedBy(
        Math.pow(10, paymentTokens[paymentTokenIndex].decimal)
      );
      const args: TypedValue[] = [
        BytesValue.fromUTF8(WEGLD_ID),
        new BigUIntValue(amount),
        BytesValue.fromUTF8('startVesting')
      ];

      if (referralId && referralId.length > 0) {
        args.push(BytesValue.fromUTF8(referralId));
      }

      const { argumentsString } = new ArgSerializer().valuesToString(args);
      const data = new TransactionPayload(`ESDTTransfer@${argumentsString}`);
      const buyTransaction = [
        {
          receiver: wrapAddress,
          gasLimit: 6000000,
          value: amount,
          data: 'wrapEgld'
        },
        {
          receiver: VESTING_CONTRACT_ADDRESS,
          gasLimit: 100000000,
          data: data.toString(),
          value: 0
        }
      ];

      await refreshAccount();
      await sendTransactions({
        transactions: buyTransaction,
        transactionsDisplayInfo: {
          processingMessage: 'Processing Buy transaction',
          errorMessage: 'An error has occured during Buy',
          successMessage: 'Buy transaction successful'
        },
        redirectAfterSign: false
      });
    } else {
      // usdc
      const amount = new BigNumber(inputAmount).multipliedBy(
        Math.pow(10, paymentTokens[paymentTokenIndex].decimal)
      );
      const args: TypedValue[] = [
        BytesValue.fromUTF8(paymentTokens[paymentTokenIndex].tokenId),
        new BigUIntValue(amount),
        BytesValue.fromUTF8('startVesting')
      ];
      if (referralId && referralId.length > 0) {
        args.push(BytesValue.fromUTF8(referralId));
      }

      const { argumentsString } = new ArgSerializer().valuesToString(args);
      const data = new TransactionPayload(`ESDTTransfer@${argumentsString}`);
      const buyTransaction = {
        data: data.toString(),
        gasLimit: 100000000,
        receiver: VESTING_CONTRACT_ADDRESS,
        value: 0
      };

      await refreshAccount();
      await sendTransactions({
        transactions: buyTransaction,
        transactionsDisplayInfo: {
          processingMessage: 'Processing Buy transaction',
          errorMessage: 'An error has occured during Buy',
          successMessage: 'Buy transaction successful'
        },
        redirectAfterSign: false
      });
    }
  };

  return (
    <div className='swap-component-border'>
      <div className='swap-component-form'>
        <div className='swap-component-mainer w-100'>
          <div className='swap-form-field swap-from'>
            <label className='title w-100 mb-2'>
              <h6>
                <b>
                  Swap from <i className='fa-solid fa-level-down-alt'></i>
                </b>
              </h6>
            </label>
            <div className='d-flex flex-row align-items-center swap-form-group'>
              <div className='d-flex flex-column input-group'>
                <input
                  type='text'
                  className='input-amount'
                  placeholder='Amount (min. $10)'
                  required
                  value={inputString}
                  onChange={(e) => {
                    const inputString = e.target.value;
                    setInputString(inputString);
                    const input = parseFloat(inputString);
                    if (inputString != '' && isNaN(input)) {
                      alert('invalid number');
                    } else {
                      setInputAmount(input);
                    }
                  }}
                />
              </div>
              <div className='d-flex flex-row align-items-center token-container'>
                <Dropdown>
                  <Dropdown.Toggle id='dropdown-basic'>
                    <div className='token-image'>
                      <img
                        src={paymentTokens[paymentTokenIndex].logo}
                        className='token-symbol'
                      />
                    </div>
                    <div className='d-flex flex-column token-name'>
                      {paymentTokens[paymentTokenIndex].symbol}
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {paymentTokens.map((item, index) => (
                      <Dropdown.Item
                        style={{ display: 'flex', alignItems: 'center' }}
                        key={index}
                        onClick={() => setPaymentTokenIndex(index)}
                      >
                        <div className='token-image'>
                          <img src={item.logo} className='token-symbol' />
                        </div>
                        <div className='d-flex flex-column token-name'>
                          {item.symbol}
                        </div>
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          <div className='price-details'>
            <>
              <div>
                <p>{`1 ${
                  paymentTokens[paymentTokenIndex].symbol
                } = ${currentPaymentTokenPrice.toFixed(5)} USDC`}</p>
              </div>
              <div>
                <p>1 EVLD = {EVLD_SALE_PRICE} USDC</p>
              </div>

              {!isNaN(inputAmount) && inputAmount > 0 ? (
                <div className='d-inline-block text-center w-100 mt-1'>
                  <p>
                    <b>
                      You get:{' '}
                      {(inputAmount * vestingAmountPerOneToken).toFixed(4)}
                    </b>
                  </p>
                  {referralId && referralId.length > 0 && inputAmount > 0 && (
                    <p>
                      <b>
                        Referral ={' '}
                        {(
                          inputAmount *
                          vestingAmountPerOneToken *
                          0.05
                        ).toFixed(4)}
                      </b>
                    </p>
                  )}
                </div>
              ) : (
                <div>
                  <p>
                    <b>You get: 0</b>
                  </p>
                </div>
              )}
            </>
          </div>
        </div>

        <div className='w-100 mt-3'>
          {isLoggedIn ? (
            <button
              disabled={props.endTimestamp < Date.now()}
              className='main-btn connect-btn w-100'
              onClick={startVesting}
            >
              <span className='btn-name'>BUY EVLD</span>
              <svg
                width='17'
                height='10'
                viewBox='0 0 17 10'
                className='btn-icon'
              >
                <path
                  d='M15.9219 4.29335L11.8893 0.566788C11.333 0.055299 10.4292 0.493718 10.4292 1.29749V2.61274C10.4292 3.12423 10.012 3.56265 9.52532 3.56265H0.903863C0.417167 3.48958 0 3.928 0 4.43949V5.46247C0 5.97396 0.417167 6.41238 0.903863 6.41238H9.52532C10.012 6.41238 10.4292 6.8508 10.4292 7.36228V8.67754C10.4292 9.48131 11.333 9.91973 11.8893 9.40824L15.9219 5.68168C16.3391 5.31633 16.3391 4.6587 15.9219 4.29335Z'
                  fill='white'
                />
              </svg>
              <svg x='0px' y='0px' viewBox='0 0 66 53' className='btn-deco'>
                <g>
                  <g>
                    <path
                      className='st0'
                      fill='#005DFF'
                      d='M1.5,51.5v-50h6c2.5,0,4.9,0.8,6.9,2.2l44.7,32.4c2.2,1.6,3.5,4.2,3.5,6.9c0,4.7-3.7,8.5-8.3,8.5H1.5z'
                    />
                    <path
                      className='st1'
                      fill='#005DFF'
                      d='M7.5,3c2.2,0,4.3,0.7,6,2l44.7,32.4c1.8,1.3,2.9,3.4,2.9,5.7c0,3.8-3.1,7-6.8,7H3V3H7.5 M7.5,0H0v53h54.2
        c5.4,0,9.8-4.5,9.8-10c0-3.2-1.5-6.2-4.1-8.1L15.3,2.5C13,0.9,10.3,0,7.5,0L7.5,0z'
                    />
                  </g>
                  <path
                    className='st2'
                    fill='#3F4B6B'
                    d='M66,31L22.2,0h29.2C63.4,0,66.2,9.7,66,14.6V31z'
                  />
                </g>
              </svg>
              <span className='btn-shadow'></span>
            </button>
          ) : (
            <Link
              className='main-btn connect-btn w-100'
              to={
                referralId && referralId.length > 0
                  ? `/unlock/${referralId}`
                  : '/unlock'
              }
            >
              <span className='btn-name'>CONNECT</span>
              <svg
                width='17'
                height='10'
                viewBox='0 0 17 10'
                className='btn-icon'
              >
                <path
                  d='M15.9219 4.29335L11.8893 0.566788C11.333 0.055299 10.4292 0.493718 10.4292 1.29749V2.61274C10.4292 3.12423 10.012 3.56265 9.52532 3.56265H0.903863C0.417167 3.48958 0 3.928 0 4.43949V5.46247C0 5.97396 0.417167 6.41238 0.903863 6.41238H9.52532C10.012 6.41238 10.4292 6.8508 10.4292 7.36228V8.67754C10.4292 9.48131 11.333 9.91973 11.8893 9.40824L15.9219 5.68168C16.3391 5.31633 16.3391 4.6587 15.9219 4.29335Z'
                  fill='white'
                />
              </svg>
              <svg x='0px' y='0px' viewBox='0 0 66 53' className='btn-deco'>
                <g>
                  <g>
                    <path
                      className='st0'
                      fill='#005DFF'
                      d='M1.5,51.5v-50h6c2.5,0,4.9,0.8,6.9,2.2l44.7,32.4c2.2,1.6,3.5,4.2,3.5,6.9c0,4.7-3.7,8.5-8.3,8.5H1.5z'
                    />
                    <path
                      className='st1'
                      fill='#005DFF'
                      d='M7.5,3c2.2,0,4.3,0.7,6,2l44.7,32.4c1.8,1.3,2.9,3.4,2.9,5.7c0,3.8-3.1,7-6.8,7H3V3H7.5 M7.5,0H0v53h54.2
                      c5.4,0,9.8-4.5,9.8-10c0-3.2-1.5-6.2-4.1-8.1L15.3,2.5C13,0.9,10.3,0,7.5,0L7.5,0z'
                    />
                  </g>
                  <path
                    className='st2'
                    fill='#3F4B6B'
                    d='M66,31L22.2,0h29.2C63.4,0,66.2,9.7,66,14.6V31z'
                  />
                </g>
              </svg>
              <span className='btn-shadow'></span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default SwapComponent;
